// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__9oLGi","pageBtn":"Pagination_pageBtn__N5Ps6","active":"Pagination_active__5zIAs"};